import { ArticlePresentationFormat, HemingwayLinkType } from '../types.js';
export function isAdvicePageLink(link) {
    var _a;
    return (link.__typename === HemingwayLinkType.Sitemap &&
        ((_a = link === null || link === void 0 ? void 0 : link.sitemapNode) === null || _a === void 0 ? void 0 : _a.presentationFormat) &&
        advicePageFormats.includes(link.sitemapNode.presentationFormat));
}
export const advicePageFormats = [
    ArticlePresentationFormat.AdvicePage,
    ArticlePresentationFormat.BrandedPage,
    ArticlePresentationFormat.AdviceHub,
    ArticlePresentationFormat.CorporatePage,
];
//# sourceMappingURL=isAdvicePageLink.js.map